import React from 'react';
import { motion } from 'framer-motion';
import { FiMapPin, FiTrendingUp, FiUsers, FiActivity } from 'react-icons/fi';

const branches = [
  { id: 1, name: 'Downtown Central', manager: 'Sarah Blake', staff: 12, revenue: '$45,000', status: 'High Performing' },
  { id: 2, name: 'Westside Mall', manager: 'Mike Ross', staff: 8, revenue: '$32,000', status: 'Stable' },
  { id: 3, name: 'North Station', manager: 'Harvey Specter', staff: 15, revenue: '$58,000', status: 'High Performing' },
  { id: 4, name: 'East Side Park', manager: 'Donna Paulsen', staff: 6, revenue: '$18,000', status: 'Low Stock' },
];

const Branches = () => {
  return (
    <div className="container-fluid p-0">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="fw-bold mb-1">Branch Network</h2>
          <p className="text-muted small mb-0">Monitor performance across all franchise locations.</p>
        </div>
        <button className="btn btn-primary px-3">Add New Branch</button>
      </div>

      <div className="row g-4">
        {branches.map((branch) => (
          <div key={branch.id} className="col-xl-6">
            <motion.div whileHover={{ scale: 1.01 }} className="glass-card p-4">
              <div className="d-flex justify-content-between align-items-start mb-4">
                <div className="d-flex gap-3">
                  <div className="p-3 rounded-3 bg-primary bg-opacity-10 text-primary">
                    <FiMapPin size={24} />
                  </div>
                  <div>
                    <h5 className="fw-bold mb-1">{branch.name}</h5>
                    <p className="text-muted small mb-0">Manager: {branch.manager}</p>
                  </div>
                </div>
                <span className={`badge ${branch.status === 'High Performing' ? 'bg-success' : branch.status === 'Low Stock' ? 'bg-danger' : 'bg-info'} bg-opacity-10 text-uppercase`} style={{ fontSize: '10px' }}>
                  {branch.status}
                </span>
              </div>

              <div className="row g-3">
                <div className="col-4">
                  <div className="p-3 rounded-3 bg-dark bg-opacity-20 border border-white border-opacity-5">
                    <div className="text-muted small mb-1 d-flex align-items-center gap-1"><FiTrendingUp size={12} /> Revenue</div>
                    <div className="fw-bold">{branch.revenue}</div>
                  </div>
                </div>
                <div className="col-4">
                  <div className="p-3 rounded-3 bg-dark bg-opacity-20 border border-white border-opacity-5">
                    <div className="text-muted small mb-1 d-flex align-items-center gap-1"><FiUsers size={12} /> Staff</div>
                    <div className="fw-bold">{branch.staff} Members</div>
                  </div>
                </div>
                <div className="col-4">
                  <div className="p-3 rounded-3 bg-dark bg-opacity-20 border border-white border-opacity-5">
                    <div className="text-muted small mb-1 d-flex align-items-center gap-1"><FiActivity size={12} /> Efficiency</div>
                    <div className="fw-bold text-success">94%</div>
                  </div>
                </div>
              </div>

              <div className="mt-4 d-flex gap-2">
                <button className="btn btn-sm glass-card border-0 text-white flex-grow-1">View Analytics</button>
                <button className="btn btn-sm glass-card border-0 text-white flex-grow-1">Manage Inventory</button>
              </div>
            </motion.div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Branches;
